import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Features from "./components/Features";
import Pricing from "./components/Pricing";
import Schedule from "./components/Schedule";
import Testimonials from "./components/Testimonials";
import Articles from "./components/Articles";
import Location from "./components/Location";
import SignUp from "./components/SignUp";
import Footer from "./components/Footer";
import ArticlePage from "./pages/ArticlePage";

function HomePage() {
  return (
    <div className="App font-body bg-[#FAFAFA] min-h-screen" data-testid="home-page">
      <Header />
      <main>
        <Hero />
        <Features />
        <Pricing />
        <Schedule />
        <Testimonials />
        <Articles />
        <Location />
        <SignUp />
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/articles/:slug" element={<ArticlePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
